<template>
  <div class="app-container">
    <form-table
      ref="baseForm"
      :queryOptions="searchFormData"
      :tableOptions="tableOptions"
      :headerTitle="headerTitle"
      :queryUrl="queryUrl"
      :btnData="btnData"
      :isNeedOperate="false"
      @clickBtn="onSelect"
      :query-permission="['system:notice:query']"
    >
    </form-table>
  </div>
</template>

<script>
import { dataCenter } from '@/utils/dataCenter'
import { getDicts } from '@/api/dict/data'
export default {
  name: 'Inventory',
  data() {
    return {
      headerTitle: '渠道数据承知',
      btnData: [{ text: '下载' }],
      searchFormData: [
        { props: 'fileName', label: '文件名', type: 'input' },
        {
          props: 'channelType',
          label: '文件类型',
          type: 'DictSelect',
          dictCode: 'sys_file_category'
        },
        {
          props: 'year',
          label: '年份',
          width: '120px',
          type: 'date',
          valueFormat: 'yyyy',
          dateFormat: 'yyyy',
          dateType: 'year'
        },
        {
          props: 'month',
          label: '月份',
          type: 'DictSelect',
          dictCode: 'sys_month',
          multiple: false
        }
      ],
      tableOptions: [
        {
          prop: 'fileName',
          label: '文件名',
          type: 'fileName',
          // titleRight: {
          rightTop: {
            left: {
              prop: 'year',
              label: '年份'
            },
            right: {
              prop: 'month',
              label: '月份',
              dictCode: 'sys_month',
              options: []
            }
          },
          rightBottom: { prop: 'channelType', label: '文件类型', dictCode: 'sys_file_category', options: [] }
          // }
        },
        // {
        //   prop: 'channelType',
        //   label: '文件类型',
        //   dictCode: 'sys_file_category'
        // },
        // {
        //   prop: 'year',
        //   label: '年份'
        // },
        // {
        //   prop: 'month',
        //   label: '月份',
        //   dictCode: 'sys_month'
        // },
        {
          prop: 'createdDate',
          label: '上传时间'
        }
      ],
      queryUrl: '/bff-dp-mobile/document/model-one/dealer-channel-inventory'
    }
  },
  created() {
    this.setOptions()
  },
  methods: {
    async setOptions() {
      const fileCategoryList = await getDicts('sys_file_category').then(res => {
        let list = []
        if (res.code === 200 && res.data.length > 0) {
          list = res.data
          console.log(list)
        }
        return list
      })
      const monthList = await getDicts('sys_month').then(res => {
        let list = []
        if (res.code === 200 && res.data.length > 0) {
          list = res.data
          console.log(list)
        }
        return list
      })
      this.tableOptions[0].rightBottom.options = fileCategoryList
      this.tableOptions[0].rightTop.right.options = monthList
    },
    onSelect(text, queryParams, list) {
      console.log(text, queryParams)
      this.daowload(list)
    },
    daowload(list) {
      dataCenter.downloadFile(list)
    }
  }
}
</script>
